/* =========================================================
   NEFERTITI NATURALS — interactions
   ========================================================= */
(function () {
  "use strict";

  /* ---------- Arrival: fade from black ---------- */
  (function () {
    const fade = document.getElementById("pageFade");
    if (!fade) return;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) { fade.classList.add("is-done"); return; }
    fade.addEventListener("animationend", () => fade.classList.add("is-done"));
    setTimeout(() => fade.classList.add("is-done"), 1600);
  })();

  /* ---------- Intro: halo around the logo outline, once on first load ---------- */
  (function () {
    const logo = document.querySelector(".brand-full img");
    if (!logo) return;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const KEY = "nn_halo_seen";
    let seen = false;
    try { seen = !!localStorage.getItem(KEY); } catch (e) {}
    if (reduce || seen) return;
    try { localStorage.setItem(KEY, "1"); } catch (e) {}
    logo.addEventListener("animationend", () => logo.classList.remove("is-glow"));
    requestAnimationFrame(() => logo.classList.add("is-glow"));
  })();

  /* ---------- Products & money come from the Shopify layer (shopify.js) ---------- */
  const NN = window.NN;
  const T = window.I18N;                  // translation engine (i18n.js)
  const PRODUCTS = NN.products;          // catalogue mapped to Shopify variants
  const money = (eur) => NN.money(eur);  // Shopify Markets–aware formatter
  const TAG_KEY = { "Best-seller": "tag_bestseller", "Rare": "tag_rare", "Nouveau": "tag_new", "Vegan": "tag_vegan" };
  const pName = (p) => T.t("prod_" + p.handle + "_name", p.name);
  const pCat = (p) => T.t("prod_" + p.handle + "_cat", p.cat);
  const pTag = (p) => (p.was ? T.t("tag_promo") : (p.tag ? T.t(TAG_KEY[p.tag] || "", p.tag) : ""));

  /* ---------- Leaf icon for cart lines ---------- */
  const LEAF = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C7 7 4 11 4 15a8 8 0 0 0 16 0c0-4-3-8-8-13z"/></svg>';
  const PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  const HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21C5 16 3 12 3 8.5A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 9 2.5C21 12 19 16 12 21z"/></svg>';

  /* ---------- Build product grid ---------- */
  const grid = document.getElementById("grid");
  PRODUCTS.forEach((p, i) => {
    const card = document.createElement("article");
    card.className = "card reveal";
    card.dataset.d = String((i % 4) + 1);
    card.dataset.handle = p.handle;
    const stars = "★★★★★";
    const imgEl = document.getElementById("prodsrc-" + p.handle);
    const imgUrl = (imgEl && (imgEl.currentSrc || imgEl.src)) || ("product-card-" + p.handle + ".webp");
    card.innerHTML = `
      <div class="card__media">
        ${p.tag ? `<span class="card__tag ${p.was ? "card__tag--sale" : ""}">${pTag(p)}</span>` : ""}
        <button class="card__fav" aria-label="Favori">${HEART}</button>
        <img class="card__img" src="${imgUrl}" alt="${pName(p)}" loading="lazy" />
      </div>
      <div class="card__body">
        <span class="card__cat">${pCat(p)}</span>
        <h3 class="card__title">${pName(p)}</h3>
        <div class="card__rating"><span class="stars">${stars}</span> ${p.rating.toFixed(1)}</div>
        <div class="card__foot">
          <div class="price">
            <span class="price__now js-price" data-price-handle="${p.handle}">${money(NN.priceOf(p.handle))}</span>
            ${NN.wasOf(p.handle) != null ? `<span class="price__was js-was" data-was-handle="${p.handle}">${money(NN.wasOf(p.handle))}</span>` : ""}
          </div>
          <button class="add-btn" data-add="${p.handle}" aria-label="${pName(p)}">${PLUS}</button>
        </div>
      </div>`;
    grid.appendChild(card);
  });

  /* ---------- Quick-detail: icons, benefit data & in-grid panel ---------- */
  const SD_ICONS = {
    leaf:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/></svg>',
    bolt:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    shield:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8"/></svg>',
    brain:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 4a2.5 2.5 0 0 0-2.45 3A2.5 2.5 0 0 0 5 9.5a2.5 2.5 0 0 0 .9 4.5A2.5 2.5 0 0 0 9.5 20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><path d="M14.5 4a2.5 2.5 0 0 1 2.45 3A2.5 2.5 0 0 1 19 9.5a2.5 2.5 0 0 1-.9 4.5A2.5 2.5 0 0 1 14.5 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>',
    target:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.4" fill="currentColor"/></svg>',
    heart:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21C5 16 3 12 3 8.5A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 9 2.5C21 12 19 16 12 21z"/></svg>',
    moon:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>',
    balance: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18M5 21h14M3 7l9-2 9 2"/><path d="M3 7l-2 5a3 3 0 0 0 6 0L5 7M19 7l-2 5a3 3 0 0 0 6 0l-2-5"/></svg>',
    muscle:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14c2-1 3-3 3-5s2-4 4-4 3 1 4 3c1 2 4 3 4 6a6 6 0 0 1-6 6H8a4 4 0 0 1-4-4z"/><path d="M11 13a3 3 0 0 0 3 3"/></svg>',
    recover: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 3 21 8 16 8"/></svg>',
    drop:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5C8 7 6 10.5 6 14a6 6 0 0 0 12 0c0-3.5-2-7-6-11.5z"/></svg>',
  };

  // tri-lingual quick-detail content (fr / en / es)
  const SD = {
    moringa: {
      desc: { fr: "Le Moringa Oleifera est l'un des aliments les plus riches en nutriments de la planète — l'arbre de vie pour l'énergie, l'immunité et l'éclat naturel.",
              en: "Moringa Oleifera is one of the most nutrient-dense foods on the planet — the tree of life for energy, immunity and natural radiance.",
              es: "La Moringa Oleifera es uno de los alimentos más ricos en nutrientes del planeta — el árbol de la vida para energía, inmunidad y resplandor natural." },
      benefits: [
        { icon: "leaf",    label: { fr: "Nutriments essentiels", en: "Essential nutrients", es: "Nutrientes esenciales" } },
        { icon: "bolt",    label: { fr: "Énergie", en: "Energy", es: "Energía" } },
        { icon: "shield",  label: { fr: "Immunité", en: "Immunity", es: "Inmunidad" } },
        { icon: "sparkle", label: { fr: "Antioxydants", en: "Antioxidants", es: "Antioxidantes" } },
      ],
      highlights: {
        title: { fr: "Éléments clés", en: "Key elements", es: "Elementos clave" },
        items: [
          { fr: "Vitamines A, B, C, D, K (forte concentration)", en: "Vitamins A, B, C, D, K (high concentration)", es: "Vitaminas A, B, C, D, K (alta concentración)" },
          { fr: "25× plus de fer que les épinards", en: "25× more iron than spinach", es: "25× más hierro que las espinacas" },
          { fr: "7× plus de vitamine C que les oranges", en: "7× more vitamin C than oranges", es: "7× más vitamina C que las naranjas" },
          { fr: "15× plus de potassium que les bananes", en: "15× more potassium than bananas", es: "15× más potasio que los plátanos" },
          { fr: "4× plus de protéines que les œufs", en: "4× more protein than eggs", es: "4× más proteínas que los huevos" },
          { fr: "10× plus de vitamine A que les carottes", en: "10× more vitamin A than carrots", es: "10× más vitamina A que las zanahorias" },
          { fr: "7× plus de calcium que le lait", en: "7× more calcium than milk", es: "7× más calcio que la leche" },
        ],
      },
      long: {
        fr: ["<strong>La feuille la plus nutritive au monde.</strong> Pour rendre notre produit aussi efficace que possible, nous avons concentré notre formule sur la feuille de moringa — non seulement la partie la plus nutritive de la plante, mais la feuille la plus riche en nutriments au monde. La feuille de moringa contient 92 nutriments et 46 types d'antioxydants !"],
        en: ["<strong>World's most nutritious leaf.</strong> To make our product as effective as possible, we focused our formula on moringa leaf — not only the most nutritious part of the moringa plant, but the most nutrient-packed leaf in the world. Moringa leaf contains 92 nutrients and 46 types of antioxidants!"],
        es: ["<strong>La hoja más nutritiva del mundo.</strong> Para que nuestro producto sea lo más eficaz posible, centramos nuestra fórmula en la hoja de moringa — no solo la parte más nutritiva de la planta, sino la hoja más rica en nutrientes del mundo. ¡La hoja de moringa contiene 92 nutrientes y 46 tipos de antioxidantes!"],
      },
      ingredients: {
        fr: "Moringa Oleifera (feuille). Autres ingrédients : Hypromellose (gélule végétale).",
        en: "Moringa Oleifera (leaf). Other ingredients: Hypromellose (vegetable capsule).",
        es: "Moringa Oleifera (hoja). Otros ingredientes: Hipromelosa (cápsula vegetal).",
      },
      figure: { src: "moringa-detail-plant.png", alt: { fr: "Feuilles de Moringa fraîches dans un bol", en: "Fresh Moringa leaves in a bowl", es: "Hojas de Moringa frescas en un cuenco" } },
      nutrition: {
        servings: "30",
        serving: { fr: "2 gélules", en: "2 Capsules", es: "2 cápsulas" },
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "Moringa Oleifera (feuille)", en: "Moringa Oleifera (leaf)", es: "Moringa Oleifera (hoja)" }, val: "800 mg", dv: "**" },
        ],
        note: { fr: "** Valeur quotidienne non établie.", en: "** Daily Value not established.", es: "** Valor diario no establecido." },
      },
    },
    lions: {
      desc: { fr: "Hericium erinaceus, le champignon de l'éveil cérébral — riche en érinacines pour la mémoire, la concentration et la santé nerveuse.",
              en: "Hericium erinaceus, the brain-awakening mushroom — rich in erinacines for memory, focus and nerve health.",
              es: "Hericium erinaceus, el hongo del despertar cerebral — rico en erinacinas para la memoria, el enfoque y la salud nerviosa." },
      benefits: [
        { icon: "brain",  label: { fr: "Mémoire", en: "Memory", es: "Memoria" } },
        { icon: "target", label: { fr: "Concentration", en: "Focus", es: "Concentración" } },
        { icon: "sparkle",label: { fr: "Système nerveux", en: "Nervous system", es: "Sistema nervioso" } },
        { icon: "heart",  label: { fr: "Humeur", en: "Mood", es: "Ánimo" } },
      ],
      highlights: {
        title: { fr: "Éléments clés", en: "Key elements", es: "Elementos clave" },
        items: [
          { fr: "Mémoire et concentration améliorées", en: "Improved memory and focus", es: "Memoria y concentración mejoradas" },
          { fr: "Soutient la croissance et la réparation nerveuses", en: "Supports healthy nerve growth & repair", es: "Apoya el crecimiento y la reparación nerviosa" },
          { fr: "Bénéfique face à des maladies comme l'Alzheimer et le Parkinson", en: "Beneficial for diseases such as Alzheimer's and Parkinson's", es: "Beneficiosa frente a enfermedades como el Alzheimer y el Parkinson" },
          { fr: "Soutien immunitaire", en: "Immune support", es: "Apoyo inmunitario" },
        ],
      },
      long: {
        fr: [
          "Le champignon Lion's Mane de Nefertiti (<em>Hericium erinaceus</em>) est un spécimen fascinant du règne fongique.",
          "À l'échelle moléculaire, le Lion's Mane présente une richesse notable en constituants biologiquement actifs — polysaccharides, érinacines, héricénones et autres métabolites secondaires. On pense que ces composés participent à une interaction complexe avec divers systèmes biologiques, suggérant des applications prometteuses pour la santé et le bien-être.",
        ],
        en: [
          "Nefertiti's Lion's Mane mushroom (<em>Hericium erinaceus</em>) represents a fascinating specimen within the fungal kingdom.",
          "At the molecular level, Lion's Mane boasts a notable richness of biologically active constituents, including polysaccharides, erinacines, hericenones and other secondary metabolites. These compounds are believed to participate in a complex interplay with various biological systems, suggesting potential applications in human health and wellness.",
        ],
        es: [
          "El hongo Melena de León de Nefertiti (<em>Hericium erinaceus</em>) representa un espécimen fascinante dentro del reino fúngico.",
          "A nivel molecular, la Melena de León posee una notable riqueza de constituyentes biológicamente activos —polisacáridos, erinacinas, hericenonas y otros metabolitos secundarios—. Se cree que estos compuestos participan en una interacción compleja con diversos sistemas biológicos, lo que sugiere posibles aplicaciones para la salud y el bienestar.",
        ],
      },
      ingredients: {
        fr: "Lion's Mane bio (Hericium erinaceus) — corps fructifère & mycélium. Autres ingrédients : gélule bio (pullulan, eau), amidon de pois bio.",
        en: "Organic Lion's Mane (Hericium erinaceus) mushroom fruiting body & mycelium. Other ingredients: organic capsule (pullulan, water), organic pea starch.",
        es: "Melena de León ecológica (Hericium erinaceus) — cuerpo fructífero y micelio. Otros ingredientes: cápsula ecológica (pululano, agua), almidón de guisante ecológico.",
      },
      figure: { src: "lions-detail-visual.png", alt: { fr: "Champignons Lion's Mane sur un tronc en forêt", en: "Lion's Mane mushrooms growing on a forest trunk", es: "Hongos Melena de León en un tronco del bosque" } },
      nutrition: {
        servings: "30",
        serving: { fr: "2 gélules véganes", en: "2 Vegan Capsules", es: "2 cápsulas veganas" },
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "Lion's Mane bio (Hericium erinaceus) — corps fructifère & mycélium (standardisé à 40 % de polysaccharides [400 mg])", en: "Organic Lion's Mane (Hericium erinaceus) mushroom fruiting body & mycelium powder (standardized to 40% polysaccharides [400 mg])", es: "Melena de León ecológica (Hericium erinaceus) — cuerpo fructífero y micelio (estandarizado al 40 % de polisacáridos [400 mg])" }, val: "1000 mg", dv: "**" },
        ],
        note: { fr: "** Valeur quotidienne non établie.", en: "** Daily Value not established.", es: "** Valor diario no establecido." },
      },
    },
    ashwa: {
      desc: { fr: "L'adaptogène ancestral par excellence — l'Ashwagandha apaise le stress, équilibre le corps et soutient un sommeil réparateur.",
              en: "The quintessential ancestral adaptogen — Ashwagandha eases stress, balances the body and supports restful sleep.",
              es: "El adaptógeno ancestral por excelencia — la Ashwagandha calma el estrés, equilibra el cuerpo y favorece un sueño reparador." },
      benefits: [
        { icon: "moon",    label: { fr: "Anti-stress", en: "Stress relief", es: "Anti-estrés" } },
        { icon: "balance", label: { fr: "Équilibre", en: "Balance", es: "Equilibrio" } },
        { icon: "drop",    label: { fr: "Sommeil", en: "Sleep", es: "Sueño" } },
        { icon: "bolt",    label: { fr: "Énergie", en: "Energy", es: "Energía" } },
      ],
      highlights: {
        title: { fr: "Éléments clés", en: "Key elements", es: "Elementos clave" },
        items: [
          { fr: "<strong>Adaptogène :</strong> aide le corps à gérer le stress et à maintenir l'équilibre.", en: "<strong>Adaptogen:</strong> helps the body manage stress and maintain balance.", es: "<strong>Adaptógeno:</strong> ayuda al cuerpo a gestionar el estrés y mantener el equilibrio." },
          { fr: "<strong>Composés actifs :</strong> les withanolides sont les principaux composés bioactifs responsables de ses effets.", en: "<strong>Active compounds:</strong> withanolides are the primary bioactive compounds responsible for its effects.", es: "<strong>Compuestos activos:</strong> los witanólidos son los principales compuestos bioactivos responsables de sus efectos." },
          { fr: "<strong>Réduction du stress :</strong> diminue le stress et l'anxiété, favorisant une sensation de calme.", en: "<strong>Stress reduction:</strong> reduces stress and anxiety, promoting a sense of calm.", es: "<strong>Reducción del estrés:</strong> reduce el estrés y la ansiedad, promoviendo una sensación de calma." },
          { fr: "<strong>Énergie et vitalité :</strong> reconnu pour stimuler l'énergie et la vitalité.", en: "<strong>Energy & vitality:</strong> known to boost energy levels and vitality.", es: "<strong>Energía y vitalidad:</strong> conocida por aumentar la energía y la vitalidad." },
          { fr: "<strong>Soutien immunitaire :</strong> renforce la fonction immunitaire.", en: "<strong>Immune support:</strong> enhances immune function.", es: "<strong>Apoyo inmunitario:</strong> refuerza la función inmunitaria." },
          { fr: "<strong>Bienfaits :</strong> la recherche suggère qu'il améliore les fonctions cognitives, réduit l'inflammation et soutient l'équilibre hormonal.", en: "<strong>Benefits:</strong> research suggests it improves cognitive function, reduces inflammation and supports hormonal balance.", es: "<strong>Beneficios:</strong> la investigación sugiere que mejora la función cognitiva, reduce la inflamación y favorece el equilibrio hormonal." },
          { fr: "<strong>Usage traditionnel :</strong> l'ashwagandha a une longue histoire dans la médecine ayurvédique traditionnelle.", en: "<strong>Traditional use:</strong> Ashwagandha has a long history in traditional Ayurvedic medicine.", es: "<strong>Uso tradicional:</strong> la ashwagandha tiene una larga historia en la medicina ayurvédica tradicional." },
        ],
      },
      long: {
        fr: ["La puissance adaptogène de l'Ashwagandha de Nefertiti se révèle pleinement lorsqu'elle dialogue avec les systèmes de réponse au stress du corps. Des recherches scientifiques suggèrent que ses composants bioactifs interagissent avec les récepteurs des hormones du stress, contribuant à réguler les changements biochimiques induits par le stress. Cette danse adaptogène offre un bouclier contre l'usure de la vie moderne, favorisant résilience et équilibre."],
        en: ["Nefertiti's Ashwagandha adaptogenic prowess takes center stage as it engages with the body's stress response systems. Scientific investigations suggest that its bioactive components interact with stress hormone receptors, ultimately contributing to the regulation of stress-induced biochemical changes. This adaptogenic dance offers a shield against the wear and tear of modern life, fostering resilience and balance."],
        es: ["La destreza adaptógena de la Ashwagandha de Nefertiti cobra protagonismo al dialogar con los sistemas de respuesta al estrés del cuerpo. Las investigaciones científicas sugieren que sus componentes bioactivos interactúan con los receptores de las hormonas del estrés, contribuyendo a regular los cambios bioquímicos inducidos por el estrés. Esta danza adaptógena ofrece un escudo frente al desgaste de la vida moderna, fomentando la resiliencia y el equilibrio."],
      },
      ingredients: {
        fr: "Ashwagandha bio (Withania somnifera, racine), poivre noir bio (Piper nigrum, fruit). Autres ingrédients : gélules de pullulan.",
        en: "Organic Ashwagandha (Withania somnifera, root), organic black pepper (Piper nigrum, fruit). Other ingredients: pullulan capsules.",
        es: "Ashwagandha ecológica (Withania somnifera, raíz), pimienta negra ecológica (Piper nigrum, fruto). Otros ingredientes: cápsulas de pululano.",
      },
      figure: { src: "ashwa-detail-visual.png", alt: { fr: "Plante d'Ashwagandha avec ses baies en forêt", en: "Ashwagandha plant with its berries in the wild", es: "Planta de Ashwagandha con sus bayas en la naturaleza" } },
      nutrition: {
        servings: "60",
        serving: { fr: "1 gélule", en: "1 Capsule", es: "1 cápsula" },
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "Ashwagandha bio (Withania somnifera) — racine", en: "Organic Ashwagandha (Withania somnifera) root", es: "Ashwagandha ecológica (Withania somnifera) raíz" }, val: "650 mg", dv: "**" },
          { label: { fr: "Poivre noir bio (Piper nigrum) — fruit", en: "Organic Black Pepper (Piper nigrum) fruit", es: "Pimienta negra ecológica (Piper nigrum) fruto" }, val: "5 mg", dv: "**" },
        ],
        note: { fr: "** Valeur quotidienne (VQ) non établie.", en: "** Daily Value (DV) not established.", es: "** Valor diario (VD) no establecido." },
      },
    },
    mush10: {
      desc: { fr: "Lion's Mane, Chaga, Reishi… dix champignons rares réunis dans une seule gélule pour l'immunité, la concentration et la vitalité.",
              en: "Lion's Mane, Chaga, Reishi… ten rare mushrooms in a single capsule for immunity, focus and vitality.",
              es: "Lion's Mane, Chaga, Reishi… diez hongos raros en una sola cápsula para inmunidad, enfoque y vitalidad." },
      benefits: [
        { icon: "shield",  label: { fr: "Immunité", en: "Immunity", es: "Inmunidad" } },
        { icon: "brain",   label: { fr: "Concentration", en: "Focus", es: "Concentración" } },
        { icon: "sparkle", label: { fr: "Antioxydants", en: "Antioxidants", es: "Antioxidantes" } },
        { icon: "bolt",    label: { fr: "Vitalité", en: "Vitality", es: "Vitalidad" } },
      ],
      highlights: {
        title: { fr: "Pourquoi cette formule se démarque", en: "Why this formula stands out", es: "Por qué esta fórmula destaca" },
        items: [
          { fr: "<strong>10 champignons fonctionnels en un seul mélange :</strong> Lion's Mane, Reishi, Cordyceps, Chaga, Queue de dinde, Maitake, Shiitake, Agaric, Champignon de Paris et Champignon noir.", en: "<strong>10 functional mushrooms in one blend:</strong> Lion's Mane, Reishi, Cordyceps, Chaga, Turkey Tail, Maitake, Shiitake, Agaricus, White Button and Black Fungus.", es: "<strong>10 hongos funcionales en una sola mezcla:</strong> Melena de León, Reishi, Cordyceps, Chaga, Cola de pavo, Maitake, Shiitake, Agaricus, Champiñón y Hongo negro." },
          { fr: "<strong>Clarté mentale & concentration :</strong> le Lion's Mane est reconnu pour soutenir les fonctions cognitives et garder l'esprit vif.", en: "<strong>Mental clarity & focus:</strong> Lion's Mane is widely known for supporting cognitive function, keeping you sharp and present.", es: "<strong>Claridad mental y enfoque:</strong> la Melena de León es reconocida por apoyar la función cognitiva y mantenerte alerta." },
          { fr: "<strong>Énergie & performance naturelles :</strong> le Cordyceps soutient l'endurance — sans stimulants ni coup de barre.", en: "<strong>Natural energy & performance:</strong> Cordyceps traditionally support stamina and endurance — without stimulants or crashes.", es: "<strong>Energía y rendimiento naturales:</strong> el Cordyceps apoya la resistencia — sin estimulantes ni bajones." },
          { fr: "<strong>Soutien immunitaire :</strong> Reishi, Queue de dinde et Chaga sont riches en composés qui soutiennent les défenses naturelles.", en: "<strong>Immune support:</strong> Reishi, Turkey Tail and Chaga are rich in compounds that support your natural defenses.", es: "<strong>Apoyo inmunitario:</strong> Reishi, Cola de pavo y Chaga son ricos en compuestos que apoyan tus defensas naturales." },
          { fr: "<strong>Équilibre adaptogène :</strong> aide le corps à s'adapter au stress et à maintenir son équilibre interne.", en: "<strong>Adaptogenic balance:</strong> helps the body adapt to stress and maintain internal balance.", es: "<strong>Equilibrio adaptógeno:</strong> ayuda al cuerpo a adaptarse al estrés y mantener el equilibrio interno." },
        ],
      },
      long: {
        fr: [
          "<strong>L.O.V.E — Living On Vegan Energy.</strong> Élevez votre esprit, renforcez votre corps, alignez-vous sur la nature. Ancré dans la sagesse ancienne et affiné pour la vie moderne, notre Complexe 10X réunit 10 champignons fonctionnels dans une formule quotidienne premium — pensée pour la clarté, l'équilibre et la vitalité du corps entier.",
          "Les guérisseurs traditionnels utilisent les champignons médicinaux depuis des millénaires. Riches en antioxydants, polysaccharides et autres composés, ils nourrissent le cerveau, renforcent les réponses immunitaires et régulent la réponse au stress — beaucoup d'entre eux étant aussi adaptogènes.",
        ],
        en: [
          "<strong>L.O.V.E — Living On Vegan Energy.</strong> Elevate your mind, strengthen your body, align with nature. Rooted in ancient wisdom and refined for modern living, our Mushroom Complex 10X combines 10 functional mushrooms into one premium daily formula — designed to support clarity, balance and whole-body vitality.",
          "Traditional healers have used medicinal mushrooms for thousands of years. Rich in antioxidants, polysaccharides and other compounds, they nourish the brain, strengthen immune responses and normalize stress responses — many of the mushrooms in this blend are also adaptogenic.",
        ],
        es: [
          "<strong>L.O.V.E — Living On Vegan Energy.</strong> Eleva tu mente, fortalece tu cuerpo, alíneate con la naturaleza. Arraigada en la sabiduría ancestral y refinada para la vida moderna, nuestra Mezcla 10X reúne 10 hongos funcionales en una fórmula diaria premium — pensada para la claridad, el equilibrio y la vitalidad de todo el cuerpo.",
          "Los sanadores tradicionales han usado hongos medicinales durante milenios. Ricos en antioxidantes, polisacáridos y otros compuestos, nutren el cerebro, refuerzan las respuestas inmunitarias y regulan la respuesta al estrés — muchos de los hongos de esta mezcla son además adaptógenos.",
        ],
      },
      ingredients: {
        fr: "Poudre de Cordyceps Sinensis, extrait de Reishi, extrait de Shiitake, Lion's Mane, mélange breveté (extraits de Maitake, Queue de dinde, Chaga, Agaric brésilien, Champignon de Paris, Champignon noir). Autres ingrédients : cellulose (gélule végétale), cellulose microcristalline, stéarate de magnésium.",
        en: "Cordyceps Sinensis powder, Reishi extract, Shiitake extract, Lion's Mane, proprietary blend (Maitake, Turkey Tail, Chaga, Royal Sun Agaricus, White Button, Black Fungus extracts). Other ingredients: cellulose (vegetable capsule), microcrystalline cellulose, magnesium stearate.",
        es: "Polvo de Cordyceps Sinensis, extracto de Reishi, extracto de Shiitake, Melena de León, mezcla patentada (extractos de Maitake, Cola de pavo, Chaga, Agaricus, Champiñón, Hongo negro). Otros ingredientes: celulosa (cápsula vegetal), celulosa microcristalina, estearato de magnesio.",
      },
      figure: { src: "mush10-detail-visual.png", alt: { fr: "Dix champignons médicinaux sur un tronc en forêt", en: "Ten medicinal mushrooms on a forest log", es: "Diez hongos medicinales sobre un tronco del bosque" } },
      nutrition: {
        servings: "30",
        serving: { fr: "2 gélules végétales", en: "2 Vegetable Capsules", es: "2 cápsulas vegetales" },
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "Cordyceps Sinensis (mycélium)", en: "Cordyceps Sinensis (mycelium)", es: "Cordyceps Sinensis (micelio)" }, val: "266 mg", dv: "**" },
          { label: { fr: "Extrait de Reishi (Ganoderma lucidum) — fruit", en: "Reishi extract (Ganoderma lucidum) — fruit", es: "Extracto de Reishi (Ganoderma lucidum) — fruto" }, val: "266 mg", dv: "**" },
          { label: { fr: "Extrait de Shiitake (Lentinus edodes) — fruit", en: "Shiitake extract (Lentinus edodes) — fruit", es: "Extracto de Shiitake (Lentinus edodes) — fruto" }, val: "266 mg", dv: "**" },
          { label: { fr: "Lion's Mane (Hericium erinaceus) — fruit", en: "Lion's Mane (Hericium erinaceus) — fruit", es: "Melena de León (Hericium erinaceus) — fruto" }, val: "266 mg", dv: "**" },
          { label: { fr: "Mélange breveté", en: "Proprietary blend", es: "Mezcla patentada" }, val: "266 mg", dv: "**" },
          { label: { fr: "Maitake, Queue de dinde, Chaga, Agaric brésilien, Champignon de Paris, Champignon noir", en: "Maitake, Turkey Tail, Chaga, Royal Sun Agaricus, White Button, Black Fungus", es: "Maitake, Cola de pavo, Chaga, Agaricus, Champiñón, Hongo negro" }, sub: true },
        ],
        note: { fr: "** Valeur quotidienne (VQ) non établie.", en: "** Daily Value (DV) not established.", es: "** Valor diario (VD) no establecido." },
      },
    },
    testo: {
      desc: { fr: "Une formule végétale de vitalité pensée pour soutenir l'énergie, la force et l'endurance au naturel.",
              en: "A plant-based vitality formula crafted to support energy, strength and endurance — naturally.",
              es: "Una fórmula vegetal de vitalidad pensada para apoyar la energía, la fuerza y la resistencia de forma natural." },
      benefits: [
        { icon: "bolt",    label: { fr: "Vitalité", en: "Vitality", es: "Vitalidad" } },
        { icon: "muscle",  label: { fr: "Force", en: "Strength", es: "Fuerza" } },
        { icon: "heart",   label: { fr: "Énergie", en: "Energy", es: "Energía" } },
        { icon: "recover", label: { fr: "Endurance", en: "Endurance", es: "Resistencia" } },
      ],
      long: {
        fr: ["<strong>Une santé épanouie commence par la régénération.</strong> Pour s'épanouir dans le monde moderne, il faut de l'endurance, de la force, de l'allant et de la persévérance — des qualités naturelles dans la jeunesse que chacun cherche à retrouver par l'alimentation, l'exercice et même les « boissons énergisantes ». Le Testosterone Booster de Nefertiti, avec son puissant mélange de facteurs de croissance, est formulé pour raviver ces aspects et vous remettre en « mode action ». Ces facteurs régulent chaque fonction cellulaire saine — du métabolisme à la réponse immunitaire — ce qui en fait le choix suprême, de l'athlète aguerri au baby-boomer."],
        en: ["<strong>Thriving health begins with regeneration.</strong> To thrive and flourish in the modern world requires stamina, endurance, strength, drive and perseverance — traits that came naturally in youth and that everyone seeks to regain through diet, exercise and even \u201Cenergy drinks.\u201D Nefertiti's Testosterone Booster, with its powerful blend of growth factors, is formulated to enliven these aspects and get you back to your \u201Cgo mode.\u201D These factors regulate every healthy cellular function — from metabolism to immune response — making it the supreme choice for everyone from the hardcore athlete to the baby boomer."],
        es: ["<strong>Una salud próspera comienza con la regeneración.</strong> Para prosperar en el mundo moderno se necesita resistencia, fuerza, empuje y perseverancia — cualidades naturales en la juventud que todos buscan recuperar mediante la dieta, el ejercicio e incluso las «bebidas energéticas». El Testosterone Booster de Nefertiti, con su potente mezcla de factores de crecimiento, está formulado para revitalizar estos aspectos y devolverte a tu «modo acción». Estos factores regulan cada función celular sana — del metabolismo a la respuesta inmunitaria — lo que lo convierte en la opción suprema, desde el atleta exigente hasta el baby boomer."],
      },
      ingredients: {
        fr: "Magnésium (oxyde de magnésium), zinc (oxyde de zinc), Tribulus Terrestris (fruit), Chrysine (Oroxylum indicum, graine), Épimède (Epimedium sagittatum), Longjack (Eurycoma longifolia, racine), baies de Saw Palmetto (Serenoa repens), baies d'aubépine (Crataegus pinnatifida), Cissus Quadrangularis (tige). Autres ingrédients : Hypromellose (gélule végétale), farine de riz, stéarate de magnésium (végétal).",
        en: "Magnesium (magnesium oxide), zinc (zinc oxide), Tribulus Terrestris (fruit), Chrysin (Oroxylum indicum, seed), Horny Goat Weed (Epimedium sagittatum), Longjack (Eurycoma longifolia, root), Saw Palmetto berries (Serenoa repens), Hawthorn berries (Crataegus pinnatifida), Cissus Quadrangularis (stem). Other ingredients: Hypromellose (vegetable capsule), rice flour, magnesium stearate (vegetable).",
        es: "Magnesio (óxido de magnesio), zinc (óxido de zinc), Tribulus Terrestris (fruto), Crisina (Oroxylum indicum, semilla), Hierba de cabra (Epimedium sagittatum), Longjack (Eurycoma longifolia, raíz), bayas de Saw Palmetto (Serenoa repens), bayas de espino (Crataegus pinnatifida), Cissus Quadrangularis (tallo). Otros ingredientes: Hipromelosa (cápsula vegetal), harina de arroz, estearato de magnesio (vegetal).",
      },
      figure: { src: "testo-detail-visual.png", alt: { fr: "Plantes, racines et baies du Testosterone Booster en forêt", en: "Testosterone Booster botanicals, roots and berries in the wild", es: "Plantas, raíces y bayas del Testosterone Booster en la naturaleza" } },
      nutrition: {
        servings: "30",
        serving: { fr: "3 gélules", en: "3 Capsules", es: "3 cápsulas" },
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "Magnésium (oxyde de magnésium)", en: "Magnesium (as magnesium oxide)", es: "Magnesio (óxido de magnesio)" }, val: "200 mg", dv: "48 %" },
          { label: { fr: "Zinc (oxyde de zinc)", en: "Zinc (as zinc oxide)", es: "Zinc (óxido de zinc)" }, val: "30 mg", dv: "273 %" },
          { label: { fr: "Tribulus Terrestris (fruit)", en: "Tribulus Terrestris (fruit)", es: "Tribulus Terrestris (fruto)" }, val: "750 mg", dv: "**" },
          { label: { fr: "Chrysine (Oroxylum indicum, graine)", en: "Chrysin (Oroxylum indicum, seed)", es: "Crisina (Oroxylum indicum, semilla)" }, val: "75 mg", dv: "**" },
          { label: { fr: "Épimède (Epimedium sagittatum, parties aériennes)", en: "Horny Goat Weed (Epimedium sagittatum, aerial)", es: "Hierba de cabra (Epimedium sagittatum, aérea)" }, val: "50 mg", dv: "**" },
          { label: { fr: "Longjack (Eurycoma longifolia, racine)", en: "Longjack (Eurycoma longifolia, root)", es: "Longjack (Eurycoma longifolia, raíz)" }, val: "50 mg", dv: "**" },
          { label: { fr: "Baies de Saw Palmetto (Serenoa repens)", en: "Saw Palmetto berries (Serenoa repens)", es: "Bayas de Saw Palmetto (Serenoa repens)" }, val: "50 mg", dv: "**" },
          { label: { fr: "Baies d'aubépine (Crataegus pinnatifida)", en: "Hawthorn berries (Crataegus pinnatifida)", es: "Bayas de espino (Crataegus pinnatifida)" }, val: "50 mg", dv: "**" },
          { label: { fr: "Cissus Quadrangularis (tige)", en: "Cissus Quadrangularis (stem)", es: "Cissus Quadrangularis (tallo)" }, val: "50 mg", dv: "**" },
        ],
        note: { fr: "** Valeur quotidienne (VQ) non établie.", en: "** Daily Value (DV) not established.", es: "** Valor diario (VD) no establecido." },
      },
    },
    goat: {
      desc: { fr: "Un mélange de plantes énergisantes — l'Épimède soutient l'énergie, la circulation et l'endurance au quotidien.",
              en: "An energizing botanical blend — Horny Goat Weed supports daily energy, circulation and endurance.",
              es: "Una mezcla botánica energizante — la Epimedium apoya la energía, la circulación y la resistencia diaria." },
      benefits: [
        { icon: "bolt",    label: { fr: "Énergie", en: "Energy", es: "Energía" } },
        { icon: "heart",   label: { fr: "Circulation", en: "Circulation", es: "Circulación" } },
        { icon: "recover", label: { fr: "Endurance", en: "Endurance", es: "Resistencia" } },
        { icon: "sparkle", label: { fr: "Vitalité", en: "Vitality", es: "Vitalidad" } },
      ],
      highlights: {
        title: { fr: "Éléments clés", en: "Key elements", es: "Elementos clave" },
        items: [
          { fr: "<strong>Composés actifs :</strong> l'icariine est le principal composé actif — elle améliore nettement la circulation sanguine et la fonction sexuelle.", en: "<strong>Active compounds:</strong> icariin is the primary active compound — it markedly improves blood flow and sexual function.", es: "<strong>Compuestos activos:</strong> la icariina es el principal compuesto activo — mejora notablemente el flujo sanguíneo y la función sexual." },
          { fr: "<strong>Effets aphrodisiaques :</strong> reconnu pour stimuler la libido et la performance sexuelle, grâce à son action sur le monoxyde d'azote.", en: "<strong>Aphrodisiac effects:</strong> known to enhance libido and sexual performance, thanks to its impact on nitric oxide levels.", es: "<strong>Efectos afrodisíacos:</strong> reconocido por aumentar la libido y el rendimiento sexual, gracias a su efecto sobre el óxido nítrico." },
          { fr: "<strong>Médecine traditionnelle :</strong> utilisé en médecine chinoise traditionnelle, notamment contre les troubles sexuels et la fatigue.", en: "<strong>Traditional medicine:</strong> used in traditional Chinese medicine, including for sexual dysfunction and fatigue.", es: "<strong>Medicina tradicional:</strong> usado en la medicina tradicional china, entre otros para la disfunción sexual y la fatiga." },
          { fr: "<strong>Bienfaits potentiels :</strong> certaines études suggèrent des effets bénéfiques sur la santé osseuse et une action anti-inflammatoire.", en: "<strong>Potential health benefits:</strong> some studies suggest benefits such as improved bone health and anti-inflammatory effects.", es: "<strong>Beneficios potenciales:</strong> algunos estudios sugieren beneficios como una mejor salud ósea y efectos antiinflamatorios." },
        ],
      },
      long: {
        fr: ["Comme l'élégance de Néfertiti illuminait les cours antiques, la nature adaptogène de ce mélange offre une danse harmonieuse avec vos voies neurochimiques, favorisant potentiellement un meilleur équilibre émotionnel. Tout comme la grâce de la reine illuminait le royaume, le potentiel de cet élixir sur l'humeur pourrait éclairer votre monde intérieur et nourrir un sentiment de bien-être accru."],
        en: ["As Nefertiti's elegance graced the ancient courts, this blend's adaptogenic nature offers a harmonious dance with your neurochemical pathways, potentially bestowing enhanced emotional equilibrium. Just as the queen's grace lit up the kingdom, this elixir's mood-enhancing potential could illuminate your inner world, fostering a heightened sense of well-being."],
        es: ["Como la elegancia de Nefertiti engalanaba las cortes antiguas, la naturaleza adaptógena de esta mezcla ofrece una danza armoniosa con tus vías neuroquímicas, propiciando un mayor equilibrio emocional. Igual que la gracia de la reina iluminaba el reino, el potencial de este elixir sobre el ánimo podría iluminar tu mundo interior, fomentando una mayor sensación de bienestar."],
      },
      ingredients: {
        fr: "Extrait d'Épimède (Horny Goat Weed, Epimedium sagittatum, parties aériennes — 100 mg d'icariines), poudre de Maca (Lepidium meyenii, racine), L-Phénylalanine, extrait de Polypode 20:1 (Polypodium vulgare), extrait de Longjack 100:1 (Eurycoma longifolia, racine), poudre de Saw Palmetto (Serenoa repens), poudre de Muira Puama (Ptychopetalum olacoides, racine), L-Arginine, poudre de Ginseng asiatique (Panax ginseng, racine). Autres ingrédients : gélule de gélatine, farine de riz, stéarate de magnésium végétal.",
        en: "Epimedium extract (Horny Goat Weed, Epimedium sagittatum, aerial — 100 mg of icariins), Maca powder (Lepidium meyenii, root), L-Phenylalanine, Polypody extract 20:1 (Polypodium vulgare), Longjack root extract 100:1 (Eurycoma longifolia), Saw Palmetto powder (Serenoa repens), Muira Puama powder (Ptychopetalum olacoides, root), L-Arginine, Asian Ginseng powder (Panax ginseng, root). Other ingredients: gelatin capsule, rice flour, vegetable magnesium stearate.",
        es: "Extracto de Epimedium (Horny Goat Weed, Epimedium sagittatum, aérea — 100 mg de icariinas), polvo de Maca (Lepidium meyenii, raíz), L-Fenilalanina, extracto de Polipodio 20:1 (Polypodium vulgare), extracto de raíz de Longjack 100:1 (Eurycoma longifolia), polvo de Saw Palmetto (Serenoa repens), polvo de Muira Puama (Ptychopetalum olacoides, raíz), L-Arginina, polvo de Ginseng asiático (Panax ginseng, raíz). Otros ingredientes: cápsula de gelatina, harina de arroz, estearato de magnesio vegetal.",
      },
      figure: { src: "goat-detail-visual.png", alt: { fr: "Plantes et racines du mélange Horny Goat Weed en forêt", en: "Horny Goat Weed blend botanicals and roots in the wild", es: "Plantas y raíces de la mezcla Horny Goat Weed en la naturaleza" } },
      nutrition: {
        servings: "30",
        serving: { fr: "2 gélules", en: "2 Capsules", es: "2 cápsulas" },
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "Extrait d'Épimède (Epimedium sagittatum, parties aériennes — 100 mg d'icariines)", en: "Epimedium extract (Epimedium sagittatum, aerial — 100 mg icariins)", es: "Extracto de Epimedium (Epimedium sagittatum, aérea — 100 mg de icariinas)" }, val: "1000 mg", dv: "**" },
          { label: { fr: "Poudre de Maca (Lepidium meyenii, racine)", en: "Maca powder (Lepidium meyenii, root)", es: "Polvo de Maca (Lepidium meyenii, raíz)" }, val: "62,5 mg", dv: "**" },
          { label: { fr: "L-Phénylalanine", en: "L-Phenylalanine", es: "L-Fenilalanina" }, val: "30 mg", dv: "**" },
          { label: { fr: "Extrait de Polypode 20:1 (Polypodium vulgare)", en: "Polypody extract 20:1 (Polypodium vulgare)", es: "Extracto de Polipodio 20:1 (Polypodium vulgare)" }, val: "1 mg", dv: "**" },
          { label: { fr: "Extrait de Longjack 100:1 (Eurycoma longifolia, racine)", en: "Longjack root extract 100:1 (Eurycoma longifolia)", es: "Extracto de raíz de Longjack 100:1 (Eurycoma longifolia)" }, val: "1 mg", dv: "**" },
          { label: { fr: "Poudre de Saw Palmetto (Serenoa repens, fruit)", en: "Saw Palmetto powder (Serenoa repens, fruit)", es: "Polvo de Saw Palmetto (Serenoa repens, fruto)" }, val: "10 mg", dv: "**" },
          { label: { fr: "Poudre de Muira Puama (Ptychopetalum olacoides, racine)", en: "Muira Puama powder (Ptychopetalum olacoides, root)", es: "Polvo de Muira Puama (Ptychopetalum olacoides, raíz)" }, val: "20 mg", dv: "**" },
          { label: { fr: "L-Arginine (base)", en: "L-Arginine (base)", es: "L-Arginina (base)" }, val: "20 mg", dv: "**" },
          { label: { fr: "Poudre de Ginseng asiatique (Panax ginseng, racine)", en: "Asian Ginseng powder (Panax ginseng, root)", es: "Polvo de Ginseng asiático (Panax ginseng, raíz)" }, val: "20 mg", dv: "**" },
        ],
        note: { fr: "** Valeur quotidienne (VQ) non établie.", en: "** Daily Value (DV) not established.", es: "** Valor diario (VD) no establecido." },
      },
    },
    coffee: {
      desc: { fr: "Le Café Vitalité, c'est la rencontre du goût et de la fonction. Cette torréfaction moyenne corsée associe des grains premium du Brésil et du Mexique aux poudres de Crinière de Lion et de Chaga, mariant une profonde saveur chocolatée aux bienfaits naturels des adaptogènes.",
              en: "Vitality Mushroom Coffee is where flavor meets function. This full-bodied medium roast combines premium beans from Brazil and Mexico with Lion's Mane and Chaga mushroom powders, bringing together deep chocolate flavor with the natural benefits of adaptogens.",
              es: "El Café Vitalidad es donde el sabor se encuentra con la función. Este tueste medio con cuerpo combina granos premium de Brasil y México con polvos de Melena de León y Chaga, uniendo un profundo sabor a chocolate con los beneficios naturales de los adaptógenos." },
      benefits: [
        { icon: "brain",   label: { fr: "Focus", en: "Focus", es: "Enfoque" } },
        { icon: "bolt",    label: { fr: "Énergie", en: "Energy", es: "Energía" } },
        { icon: "sparkle", label: { fr: "Antioxydants", en: "Antioxidants", es: "Antioxidantes" } },
        { icon: "moon",    label: { fr: "Sans nervosité", en: "No jitters", es: "Sin nervios" } },
      ],
      long: {
        fr: [
          "Le mélange est élaboré à partir de variétés soigneusement sélectionnées : Bourbon, Typica, Catuaí, Catucaí et Mundo Novo. Vous retrouvez le goût franc et réconfortant d'une tasse traditionnelle, équilibré par de subtiles notes terreuses, tout en soutenant l'énergie, la concentration et la vitalité. Conçu pour vous garder vif sans coup de barre, il est idéal pour votre rituel du matin ou un regain en milieu de journée.",
          "Un café plus intelligent, pensé pour votre rythme de vie.",
        ],
        en: [
          "The blend is made from carefully selected Bourbon, Typica, Catuaí, Catucaí, and Mundo Novo varietals. You get the bold, comforting taste of a traditional cup, balanced with subtle earthy undertones plus support for energy, focus, and vitality. Crafted to help you feel sharp without the crash, it's ideal for your morning ritual or mid-day lift.",
          "A smarter kind of coffee, made for how you move.",
        ],
        es: [
          "La mezcla se elabora con variedades cuidadosamente seleccionadas: Bourbon, Typica, Catuaí, Catucaí y Mundo Novo. Obtienes el sabor intenso y reconfortante de una taza tradicional, equilibrado con sutiles matices terrosos, además de apoyo para la energía, el enfoque y la vitalidad. Creado para mantenerte agudo sin el bajón, es ideal para tu ritual matutino o un impulso a media jornada.",
          "Un café más inteligente, hecho para tu ritmo.",
        ],
      },
      ingredients: {
        fr: "90 % café Arabica torréfié, 5 % poudre de Crinière de Lion bio, 5 % poudre de champignon Chaga bio.",
        en: "90% Roasted Arabica Coffee, 5% Organic Lion's Mane Powder, 5% Organic Chaga Mushroom Powder.",
        es: "90 % café Arábica tostado, 5 % polvo de Melena de León ecológico, 5 % polvo de hongo Chaga ecológico.",
      },
      specs: [
        { dt: { fr: "Quantité", en: "Amount", es: "Cantidad" }, dd: { fr: "12 oz / 0,8 lb / 340 g", en: "12 oz / 0.8 lb / 340 g", es: "12 oz / 0,8 lb / 340 g" } },
        { dt: { fr: "Poids brut", en: "Gross weight", es: "Peso bruto" }, dd: { fr: "13,5 oz / 0,8 lb / 383 g", en: "13.5 oz / 0.8 lb / 383 g", es: "13,5 oz / 0,8 lb / 383 g" } },
      ],
      warning: {
        fr: "Ne pas utiliser si l'emballage est endommagé ou ouvert. Conserver dans un endroit frais et sec, à l'abri de la lumière directe et de l'humidité.",
        en: "Do not use if the packaging is damaged or opened. Store in a cool, dry place, away from direct sunlight and moisture.",
        es: "No usar si el envase está dañado o abierto. Conservar en un lugar fresco y seco, lejos de la luz solar directa y la humedad.",
      },
      nutrition: {
        servings: "34",
        serving: { fr: "1 c. à soupe (10 g)", en: "1 Tbsp (10 g)", es: "1 cda (10 g)" },
        calories: "6",
        rows: [
          { label: { fr: "Lipides totaux", en: "Total Fat", es: "Grasas totales" }, val: "0 g", dv: "0 %" },
          { label: { fr: "dont saturés", en: "Sat. Fat", es: "Grasas saturadas" }, val: "0 g", dv: "0 %", sub: true },
          { label: { fr: "dont trans", en: "Trans Fat", es: "Grasas trans" }, val: "0 g", sub: true },
          { label: { fr: "Cholestérol", en: "Cholesterol", es: "Colesterol" }, val: "0 mg", dv: "0 %" },
          { label: { fr: "Sodium", en: "Sodium", es: "Sodio" }, val: "4 mg", dv: "0 %" },
          { label: { fr: "Glucides totaux", en: "Total Carb.", es: "Carbohidratos" }, val: "<1 g" },
          { label: { fr: "Fibres", en: "Fiber", es: "Fibra" }, val: "0 g", dv: "0 %", sub: true },
          { label: { fr: "Sucres totaux", en: "Total Sugars", es: "Azúcares totales" }, val: "0 g", dv: "0 %", sub: true },
          { label: { fr: "Protéines", en: "Protein", es: "Proteínas" }, val: "0 g" },
        ],
        micros: [
          { label: { fr: "Vit. D", en: "Vit. D", es: "Vit. D" }, dv: "0 %" },
          { label: { fr: "Calcium", en: "Calcium", es: "Calcio" }, dv: "0 %" },
          { label: { fr: "Fer", en: "Iron", es: "Hierro" }, dv: "0 %" },
          { label: { fr: "Potassium", en: "Potassium", es: "Potasio" }, dv: "0 %" },
        ],
      },
      figure: { src: { fr: "coffee-detail-beans.png", en: "coffee-detail-beans-en.png", es: "coffee-detail-beans-es.png" }, alt: { fr: "Café Vitalité — variétés et origines des grains", en: "Vitality Coffee — bean varietals and origins", es: "Café Vitalidad — variedades y orígenes del grano" } },
    },
    protein: {
      desc: { fr: "Sublimez votre nutrition avec notre Protéine Végétale (Vanille) — une poudre délicieuse et polyvalente pensée pour accompagner un mode de vie actif. Chaque portion offre un profil complet d'acides aminés essentiels à la réparation et à la croissance musculaire, idéale en shake de récupération post-entraînement.",
              en: "Enhance your nutrition with our Plant Protein (Vanilla) — a delicious, versatile protein powder designed to support your active lifestyle. Each serving provides a complete amino acid profile essential for muscle repair and growth, making it an ideal post-workout recovery shake.",
              es: "Realza tu nutrición con nuestra Proteína Vegetal (Vainilla) — un polvo delicioso y versátil pensado para acompañar un estilo de vida activo. Cada porción aporta un perfil completo de aminoácidos esenciales para la reparación y el crecimiento muscular, ideal como batido de recuperación post-entrenamiento." },
      benefits: [
        { icon: "muscle",  label: { fr: "20 g protéines", en: "20 g protein", es: "20 g proteína" } },
        { icon: "recover", label: { fr: "Récupération", en: "Recovery", es: "Recuperación" } },
        { icon: "leaf",    label: { fr: "100 % Vegan", en: "100% Vegan", es: "100 % Vegana" } },
        { icon: "drop",    label: { fr: "Faible en calories", en: "Low calorie", es: "Bajo en calorías" } },
      ],
      highlights: {
        title: { fr: "Bienfaits santé", en: "Health benefits", es: "Beneficios para la salud" },
        items: [
          { fr: "<strong>Protéine végétale de qualité :</strong> 20 g par portion d'un mélange puissant d'isolat de protéine de fève et de protéine de levure nutritionnelle fermentée YESTEIN™ pour soutenir la récupération et la croissance musculaire.", en: "<strong>High-quality plant protein:</strong> 20 g per serving of a powerful blend of Fava Bean Protein Isolate and YESTEIN™ Fermented Nutritional Yeast Protein to support muscle recovery and growth.", es: "<strong>Proteína vegetal de calidad:</strong> 20 g por porción de una potente mezcla de aislado de proteína de haba y proteína de levadura nutricional fermentada YESTEIN™ para la recuperación y el crecimiento muscular." },
          { fr: "<strong>Faible en calories et nutritive :</strong> seulement 110 kcal par portion, tous les acides aminés essentiels et de la pectine de pomme pour le soutien digestif.", en: "<strong>Low-calorie & nutrient-dense:</strong> just 110 kcal per serving, all essential amino acids plus apple pectin powder for digestive support.", es: "<strong>Baja en calorías y nutritiva:</strong> solo 110 kcal por porción, todos los aminoácidos esenciales y pectina de manzana para el apoyo digestivo." },
          { fr: "<strong>Saveur vanille onctueuse & bons lipides :</strong> un goût crémeux rehaussé d'huile MCT en poudre pour une énergie rapide et le métabolisme.", en: "<strong>Smooth vanilla flavor with healthy fats:</strong> a creamy taste enhanced with MCT oil powder for quick energy and metabolism.", es: "<strong>Sabor vainilla suave y grasas saludables:</strong> un gusto cremoso con aceite MCT en polvo para energía rápida y metabolismo." },
          { fr: "<strong>Gestion du poids :</strong> l'association protéines + fibres augmente la sensation de satiété et aide à la gestion du poids.", en: "<strong>Weight management:</strong> the protein + fiber combination increases feelings of fullness, aiding weight management.", es: "<strong>Control del peso:</strong> la combinación de proteína y fibra aumenta la saciedad y ayuda al control del peso." },
          { fr: "<strong>Adapté aux allergènes & digestion :</strong> sans produits laitiers, soja ni gluten, avec de la lécithine de tournesol pour une meilleure miscibilité.", en: "<strong>Allergen-friendly & digestive health:</strong> free from dairy, soy and gluten, with sunflower lecithin for enhanced mixability.", es: "<strong>Apta para alérgicos y salud digestiva:</strong> sin lácteos, soja ni gluten, con lecitina de girasol para una mejor mezcla." },
        ],
      },
      long: {
        fr: ["Élaborée à partir d'ingrédients végétaux de haute qualité, notre formule est sans produits laitiers, soja ni gluten — adaptée aux régimes restrictifs. Savourez sa vanille douce et crémeuse dans vos boissons, smoothies ou recettes préférés, et adoptez une protéine plus saine, pour vos objectifs bien-être comme pour la planète.*"],
        en: ["Made from high-quality plant-based ingredients, our formula is free from dairy, soy and gluten — suitable for dietary restrictions. Enjoy the smooth, creamy vanilla flavor in your favorite beverages, smoothies or recipes, and embrace a healthier protein that supports both your wellness goals and the environment.*"],
        es: ["Elaborada con ingredientes vegetales de alta calidad, nuestra fórmula es sin lácteos, soja ni gluten — apta para dietas restrictivas. Disfruta su sabor a vainilla suave y cremoso en tus bebidas, batidos o recetas favoritos, y adopta una proteína más saludable, para tus objetivos de bienestar y para el planeta.*"],
      },
      ingredients: {
        fr: "Isolat de protéine de fève Tendra®, arômes naturels, protéine de levure nutritionnelle fermentée YESTEIN™, huile MCT en poudre, pectine de pomme en poudre, sel de mer, extrait de stévia (feuille), dioxyde de silicium.",
        en: "Tendra® Fava Bean Protein Isolate, Natural Flavors, YESTEIN™ Fermented Nutritional Yeast Protein, MCT Oil Powder, Apple Pectin Powder, Sea Salt, Stevia Extract (leaf), Silicon Dioxide.",
        es: "Aislado de proteína de haba Tendra®, aromas naturales, proteína de levadura nutricional fermentada YESTEIN™, aceite MCT en polvo, pectina de manzana en polvo, sal marina, extracto de estevia (hoja), dióxido de silicio.",
      },
      specs: [
        { dt: { fr: "Saveur", en: "Flavor", es: "Sabor" }, dd: { fr: "Vanille", en: "Vanilla", es: "Vainilla" } },
        { dt: { fr: "Quantité", en: "Amount", es: "Cantidad" }, dd: { fr: "29,77 oz / 844 g", en: "29.77 oz / 844 g", es: "29,77 oz / 844 g" } },
        { dt: { fr: "Poids brut", en: "Gross weight", es: "Peso bruto" }, dd: { fr: "2 lb / 910 g", en: "2 lb / 910 g", es: "2 lb / 910 g" } },
        { dt: { fr: "Pays de fabrication", en: "Manufacturer's country", es: "País de fabricación" }, dd: { fr: "USA", en: "USA", es: "EE. UU." } },
        { dt: { fr: "Conseil d'utilisation", en: "Suggested use", es: "Modo de empleo" }, dd: { fr: "Mélanger 2 mesures dans 180–240 ml d'eau ou de boisson, 1×/jour. Idéalement 20–30 min avant un repas avec 240 ml d'eau, ou selon l'avis d'un professionnel de santé.", en: "Mix 2 scoops with 6–8 oz of water or beverage daily. Best taken 20–30 minutes before a meal with 8 oz of water, or as directed by your healthcare professional.", es: "Mezclar 2 cucharadas en 180–240 ml de agua o bebida, 1 vez/día. Idealmente 20–30 min antes de una comida con 240 ml de agua, o según indicación de un profesional de salud." } },
      ],
      figure: { src: "protein-detail-visual.png", alt: { fr: "Ingrédients végétaux : fève, levure nutritionnelle, vanille, coco, pomme et stévia", en: "Plant ingredients: fava bean, nutritional yeast, vanilla, coconut, apple and stevia", es: "Ingredientes vegetales: haba, levadura nutricional, vainilla, coco, manzana y estevia" } },
      nutrition: {
        servings: "24",
        serving: { fr: "2 mesures (35 g)", en: "2 Scoops (35 g)", es: "2 cucharadas (35 g)" },
        calories: "110",
        amountHead: { fr: "Quantité / portion", en: "Amount Per Serving", es: "Cantidad por porción" },
        rows: [
          { label: { fr: "dont lipides", en: "Calories From Fat", es: "Calorías de grasa" }, val: "5", sub: true },
          { label: { fr: "Lipides totaux", en: "Total Fat", es: "Grasas totales" }, val: "0,5 g", dv: "<1 %" },
          { label: { fr: "Glucides totaux", en: "Total Carb.", es: "Carbohidratos" }, val: "6 g", dv: "2 %" },
          { label: { fr: "Sucres totaux", en: "Total Sugars", es: "Azúcares totales" }, val: "4 g", dv: "***", sub: true },
          { label: { fr: "Protéines", en: "Protein", es: "Proteínas" }, val: "20 g", dv: "***" },
          { label: { fr: "Sodium", en: "Sodium", es: "Sodio" }, val: "180 mg", dv: "8 %" },
          { label: { fr: "Potassium", en: "Potassium", es: "Potasio" }, val: "5 mg", dv: "<1 %" },
        ],
        note: { fr: "*** Valeur quotidienne (VQ) non établie.", en: "*** Daily Value (DV) not established.", es: "*** Valor diario (VD) no establecido." },
      },
      warning: {
        fr: "Ne pas dépasser la dose recommandée. Les femmes enceintes ou allaitantes, les enfants de moins de 18 ans et les personnes ayant un problème de santé connu doivent consulter un médecin avant utilisation. TENIR HORS DE PORTÉE DES ENFANTS. NE PAS UTILISER SI LE SCEAU DE SÉCURITÉ EST ENDOMMAGÉ OU MANQUANT. CONSERVER DANS UN ENDROIT FRAIS ET SEC.",
        en: "Do not exceed recommended dose. Pregnant or nursing mothers, children under 18, and individuals with a known medical condition should consult a physician before use. KEEP OUT OF THE REACH OF CHILDREN. DO NOT USE IF SAFETY SEAL IS DAMAGED OR MISSING. STORE IN A COOL, DRY PLACE.",
        es: "No exceder la dosis recomendada. Las mujeres embarazadas o lactantes, los menores de 18 años y las personas con una afección médica conocida deben consultar a un médico antes de usarlo. MANTENER FUERA DEL ALCANCE DE LOS NIÑOS. NO USAR SI EL SELLO DE SEGURIDAD ESTÁ DAÑADO O AUSENTE. CONSERVAR EN UN LUGAR FRESCO Y SECO.",
      },
    },
  };

  const SD_BACK = { fr: "Tous les produits", en: "All products", es: "Todos los productos" };
  const SD_BACK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';
  const SD_DOWN_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';

  // reveal the decorative figure on scroll
  const sdFadeObserver = ("IntersectionObserver" in window)
    ? new IntersectionObserver((entries, obs) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-vis"); obs.unobserve(en.target); } });
      }, { threshold: 0.18 })
    : { observe: (el) => el.classList.add("is-vis") };

  const detail = document.createElement("div");
  detail.className = "shop-detail";
  detail.id = "shopDetail";
  detail.hidden = true;
  grid.after(detail);

  let detailOpen = false;
  let detailHandle = null;

  function buildDetail(handle) {
    const p = NN.byHandle(handle);
    if (!p) return;
    const L = T.lang;
    const pick = (o) => (o ? (o[L] != null ? o[L] : o.fr) : "");
    const info = SD[handle] || { desc: {}, benefits: [] };
    const imgEl = document.getElementById("prodsrc-" + handle);
    const imgUrl = (imgEl && (imgEl.currentSrc || imgEl.src)) || ("product-card-" + handle + ".webp");
    const bens = (info.benefits || []).map((b, i) =>
      `<div class="sd-benefit" style="--bi:${i}"><span class="sd-benefit__ic">${SD_ICONS[b.icon] || SD_ICONS.leaf}</span><span class="sd-benefit__lb">${pick(b.label)}</span></div>`
    ).join("");

    // ---- optional extended content (long copy, ingredients, specs, nutrition, warning) ----
    const H = {
      desc:    { fr: "Description", en: "Description", es: "Descripción" },
      ing:     { fr: "Ingrédients", en: "Ingredients", es: "Ingredientes" },
      details: { fr: "Détails produit", en: "Product details", es: "Detalles del producto" },
      nutri:   { fr: "Valeurs nutritionnelles", en: "Nutrition Facts", es: "Información nutricional" },
      servings:{ fr: "Portions", en: "Servings", es: "Porciones" },
      serving: { fr: "Portion", en: "Serving size", es: "Tamaño de porción" },
      cal:     { fr: "Calories", en: "Calories", es: "Calorías" },
      dv:      { fr: "% VQ*", en: "% DV*", es: "% VD*" },
      caution: { fr: "Précautions", en: "Warning", es: "Precaución" },
      morehint:{ fr: "Plus de détails", en: "More details", es: "Más detalles" },
      dvnote:  { fr: "* Pourcentage des valeurs quotidiennes basé sur un régime de 2 000 calories.", en: "* Percent Daily Values are based on a 2,000 calorie diet.", es: "* Los porcentajes de valores diarios se basan en una dieta de 2.000 calorías." },
    };
    let more = "";
    // left column: description, ingredients, quantity/weight, nutrition facts
    let col = "";
    const longs = info.long ? pick(info.long) : null;

    // key-elements highlights (rendered before the long copy)
    if (info.highlights && info.highlights.items && info.highlights.items.length) {
      const lis = info.highlights.items.map((it) => `<li>${pick(it)}</li>`).join("");
      col += `<div class="sd-block sd-highlights"><h4>${pick(info.highlights.title)}</h4><ul class="sd-keylist">${lis}</ul></div>`;
    }

    if (longs && longs.length) col += longs.map((t) => `<p class="sd-desc sd-more__p">${t}</p>`).join("");

    if (info.ingredients) {
      col += `<div class="sd-block"><h4>${pick(H.ing)}</h4><p>${pick(info.ingredients)}</p></div>`;
    }
    if (info.specs && info.specs.length) {
      const rows = info.specs.map((s) => `<div><dt>${pick(s.dt)}</dt><dd>${pick(s.dd)}</dd></div>`).join("");
      col += `<div class="sd-block"><h4>${pick(H.details)}</h4><dl class="pmodal__specs">${rows}</dl></div>`;
    }
    if (info.nutrition) {
      const n = info.nutrition;
      const nrows = (n.rows || []).map((r) =>
        `<div class="sd-nutri__row${r.sub ? " is-sub" : ""}"><span class="sd-nutri__lb">${pick(r.label)}${r.val ? ` <b>${r.val}</b>` : ""}</span><span class="sd-nutri__dv">${r.dv || ""}</span></div>`
      ).join("");
      const micros = (n.micros || []).map((m) => `<span>${pick(m.label)} ${m.dv}</span>`).join("");
      col += `<div class="sd-block sd-block--nutri"><h4>${pick(H.nutri)}</h4>
        <div class="sd-nutri">
          <div class="sd-nutri__meta"><span>${pick(H.servings)}: <b>${n.servings}</b></span><span>${pick(H.serving)}: <b>${pick(n.serving)}</b></span></div>
          ${n.calories ? `<div class="sd-nutri__cal"><span>${pick(H.cal)}</span><b>${n.calories}</b></div>` : ""}
          <div class="sd-nutri__head"><span>${n.amountHead ? pick(n.amountHead) : ""}</span><span>${pick(H.dv)}</span></div>
          ${nrows}
          ${micros ? `<div class="sd-nutri__micros">${micros}</div>` : ""}
          <p class="sd-nutri__note">${n.note ? pick(n.note) : pick(H.dvnote)}</p>
        </div></div>`;
    }

    // right column: decorative visual, fades in, same height as the description
    const figRaw = info.figure ? (typeof info.figure.src === "object" ? pick(info.figure.src) : info.figure.src) : "";
    const figSrc = figRaw ? ((window.NN_ASSET_BASE || "") + figRaw) : "";
    const figHtml = info.figure
      ? `<figure class="sd-figure"><img src="${figSrc}" alt="${pick(info.figure.alt)}" /></figure>`
      : "";

    if (col || figHtml) more += `<div class="sd-more__layout">${col ? `<div class="sd-more__col">${col}</div>` : ""}${figHtml}</div>`;
    if (info.warning) more += `<p class="pmodal__caution sd-more__warn"><strong>${pick(H.caution)} :</strong> ${pick(info.warning)}</p>`;
    const moreHtml = more ? `<div class="sd-more" id="sdMore">${more}</div>` : "";
    const hintHtml = more ? `<button class="sd-scrolldown" type="button" data-sdmore aria-label="${pick(H.morehint)}" title="${pick(H.morehint)}"><span class="sd-scrolldown__btn">${SD_DOWN_SVG}</span></button>` : "";

    detail.innerHTML = `
      <button class="sd-back" type="button" data-sdback>${SD_BACK_SVG}<span>${pick(SD_BACK)}</span></button>
      <div class="sd-grid">
        <div class="sd-media"><img src="${imgUrl}" alt="${pName(p)}" />${hintHtml}</div>
        <div class="sd-info">
          <span class="card__cat">${pCat(p)}</span>
          <h3 class="sd-title">${pName(p)}</h3>
          <div class="card__rating"><span class="stars">★★★★★</span> ${p.rating.toFixed(1)}</div>
          <p class="sd-desc">${pick(info.desc)}</p>
          <div class="sd-benefits">${bens}</div>
          <div class="sd-foot">
            <div class="price"><span class="price__now js-price" data-price-handle="${handle}">${money(NN.priceOf(handle))}</span>${NN.wasOf(handle) != null ? `<span class="price__was js-was" data-was-handle="${handle}">${money(NN.wasOf(handle))}</span>` : ""}</div>
            <button class="btn btn--primary" data-add="${handle}"><span>${T.t("spot_add")}</span> <span class="arr">→</span></button>
          </div>
        </div>
      </div>${moreHtml}`;

    // fade the decorative figure in when it scrolls into view
    const fig = detail.querySelector(".sd-figure");
    if (fig) sdFadeObserver.observe(fig);
  }

  const RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // gentle, eased scroll (softer than native smooth-scroll)
  function gentleScrollTo(targetY, duration) {
    const startY = window.scrollY;
    const dist = targetY - startY;
    if (RM || Math.abs(dist) < 2) { window.scrollTo(0, targetY); return; }
    const t0 = performance.now();
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const step = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      window.scrollTo(0, startY + dist * ease(p));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  function openDetail(handle) {
    if (detailOpen) return;
    detailOpen = true;
    detailHandle = handle;
    buildDetail(handle);
    grid.style.opacity = "0";
    grid.style.transform = "scale(0.98)";
    grid.style.pointerEvents = "none";
    const reveal = () => {
      grid.style.display = "none";
      detail.hidden = false;
      detail.getBoundingClientRect();
      requestAnimationFrame(() => detail.classList.add("is-in"));
      // bring the "Tous les produits" back button to the top of the viewport
      const header = document.querySelector(".header");
      const hh = header ? header.offsetHeight : 0;
      const top = detail.getBoundingClientRect().top + window.scrollY - hh - 20;
      gentleScrollTo(Math.max(0, top), 600);
    };
    RM ? reveal() : setTimeout(reveal, 360);
  }

  function closeDetail() {
    if (!detailOpen) return;
    detailOpen = false;
    detailHandle = null;
    detail.classList.remove("is-in");
    const restore = () => {
      detail.hidden = true;
      grid.style.display = "";
      grid.getBoundingClientRect();
      requestAnimationFrame(() => {
        grid.style.opacity = "";
        grid.style.transform = "";
        grid.style.pointerEvents = "";
      });
    };
    RM ? restore() : setTimeout(restore, 320);
  }

  /* re-localize catalogue text on language change (without rebuilding image-slots) */
  function refreshCatalog() {
    document.querySelectorAll(".card[data-handle]").forEach((card) => {
      const p = NN.byHandle(card.dataset.handle);
      if (!p) return;
      card.querySelector(".card__title").textContent = pName(p);
      card.querySelector(".card__cat").textContent = pCat(p);
      const tagEl = card.querySelector(".card__tag");
      if (tagEl) tagEl.textContent = pTag(p);
      const slot = card.querySelector("image-slot");
      if (slot) slot.setAttribute("placeholder", pName(p));
    });
    if (detailOpen && detailHandle) buildDetail(detailHandle);
  }

  /* ---------- Cart (backed by the Shopify layer) ---------- */
  const cart = NN.cart;
  const els = {
    count: document.getElementById("cartCount"),
    items: document.getElementById("drawerItems"),
    foot: document.getElementById("drawerFoot"),
    subtotal: document.getElementById("subtotal"),
    total: document.getElementById("total"),
    shipNote: document.getElementById("shipNote"),
    drawer: document.getElementById("drawer"),
    scrim: document.getElementById("scrim"),
  };

  function openCart() { els.drawer.classList.add("is-open"); els.scrim.classList.add("is-open"); }
  function closeCart() { els.drawer.classList.remove("is-open"); els.scrim.classList.remove("is-open"); }

  function addToCart(handle) {
    cart.add(handle);
    openCart();
  }
  function setQty(handle, d) { cart.update(handle, d); }
  function removeItem(handle) { cart.remove(handle); }

  function render() {
    const items = cart.items();
    const count = cart.count();

    els.count.textContent = String(count);
    els.count.classList.toggle("is-on", count > 0);

    if (items.length === 0) {
      els.items.innerHTML = `
        <div class="drawer__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M12 2C7 7 4 11 4 15a8 8 0 0 0 16 0c0-4-3-8-8-13z"/></svg>
          <p>${T.t("cart_empty_1")}</p>
          <p style="margin-top:.4rem;font-size:.85rem;">${T.t("cart_empty_2")}</p>
        </div>`;
      els.foot.hidden = true;
      return;
    }

    els.foot.hidden = false;
    els.items.innerHTML = "";
    items.forEach(({ product: p, qty, lineTotalEur, handle }) => {
      const line = document.createElement("div");
      line.className = "line";
      const imgEl = document.getElementById("prodsrc-" + handle);
      const imgUrl = (imgEl && (imgEl.currentSrc || imgEl.src)) || ((window.NN_ASSET_BASE || "") + "product-card-" + handle + ".webp");
      line.innerHTML = `
        <div class="line__img"><img src="${imgUrl}" alt="${pName(p)}" loading="lazy" /></div>
        <div class="line__info">
          <div class="line__name">${pName(p)}</div>
          <div class="line__price">${money(lineTotalEur)}</div>
          <div class="qty">
            <button data-dec="${handle}" aria-label="${T.t("cart_less")}">−</button>
            <span>${qty}</span>
            <button data-inc="${handle}" aria-label="${T.t("cart_more")}">+</button>
          </div>
        </div>
        <button class="line__rm" data-rm="${handle}">${T.t("cart_remove")}</button>`;
      els.items.appendChild(line);
    });

    const subtotal = cart.subtotalEur();
    els.subtotal.textContent = money(subtotal);
    els.total.textContent = money(subtotal);
    const left = cart.freeShipLeftEur();
    els.shipNote.textContent = left > 0
      ? T.tf("ship_left", money(left))
      : T.t("ship_done");
  }

  /* ---------- Amazon (G&G) section — Europe + UK only ---------- */
  const AMZ = {
    eyebrow: { fr: "Sélection partenaire", en: "Partner selection", es: "Selección partner" },
    title:   { fr: "Aussi disponible sur Amazon", en: "Also available on Amazon", es: "También disponible en Amazon" },
    sub:     { fr: "Une sélection G&G, expédiée par Amazon — disponible en Europe et au Royaume-Uni.",
               en: "A G&G selection, fulfilled by Amazon — available across Europe and the UK.",
               es: "Una selección G&G, gestionada por Amazon — disponible en Europa y el Reino Unido." },
    buy:     { fr: "Acheter sur Amazon", en: "Buy on Amazon", es: "Comprar en Amazon" },
  };
  const amazonSection = document.getElementById("amazon");
  const amazonGrid = document.getElementById("amazonGrid");
  function renderAmazon() {
    if (!amazonSection || !amazonGrid) return;
    const pick = (o) => (o ? (o[T.lang] != null ? o[T.lang] : o.fr) : "");
    const visible = NN.amazonVisible();
    amazonSection.hidden = !visible;
    if (!visible) { amazonGrid.innerHTML = ""; return; }
    const eb = document.getElementById("amazonEyebrow");
    const ti = document.getElementById("amazonTitle");
    const su = document.getElementById("amazonSub");
    if (eb) eb.textContent = pick(AMZ.eyebrow);
    if (ti) ti.textContent = pick(AMZ.title);
    if (su) su.textContent = pick(AMZ.sub);
    amazonGrid.innerHTML = "";
    NN.amazonProducts().forEach((p) => {
      const imgUrl = (window.NN_ASSET_BASE || "") + (p.image || "");
      const card = document.createElement("article");
      card.className = "card card--amazon";
      card.innerHTML = `
        <div class="card__media">
          <span class="card__tag card__tag--amazon">Amazon</span>
          <img class="card__img" src="${imgUrl}" alt="${pick(p.name)}" loading="lazy" />
        </div>
        <div class="card__body">
          <span class="card__cat">${pick(p.cat)}</span>
          <h3 class="card__title">${pick(p.name)}</h3>
          ${p.price ? `<div class="price"><span class="price__now">${pick(p.price)}</span></div>` : ""}
          <a class="btn btn--amazon" href="${NN.amazonUrl(p)}" target="_blank" rel="noopener noreferrer">
            <span>${pick(AMZ.buy)}</span> <span class="arr">↗</span>
          </a>
        </div>`;
      amazonGrid.appendChild(card);
    });
  }

  /* keep every price label in sync with the active Shopify market */
  function refreshPrices() {
    document.querySelectorAll(".js-price[data-price-handle]").forEach((el) => {
      const p = NN.byHandle(el.dataset.priceHandle);
      if (p) el.textContent = money(NN.priceOf(p.handle));
    });
    document.querySelectorAll(".js-was[data-was-handle]").forEach((el) => {
      const p = NN.byHandle(el.dataset.wasHandle);
      if (!p) return;
      const w = NN.wasOf(p.handle);
      if (w != null) { el.textContent = money(w); el.style.display = ""; }
      else { el.style.display = "none"; }
    });
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-sdback]")) { closeDetail(); return; }
    if (e.target.closest("[data-sdmore]")) {
      const more = document.getElementById("sdMore");
      if (more) {
        const header = document.querySelector(".header");
        const hh = header ? header.offsetHeight : 0;
        gentleScrollTo(Math.max(0, more.getBoundingClientRect().top + window.scrollY - hh - 20), 600);
      }
      return;
    }
    const media = e.target.closest(".card__media");
    if (media && !e.target.closest(".card__fav")) {
      const card = media.closest(".card[data-handle]");
      if (card) { openDetail(card.dataset.handle); return; }
    }
    const add = e.target.closest("[data-add]");
    if (add) {
      addToCart(add.dataset.add);
      add.classList.add("added");
      add.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg>';
      setTimeout(() => { add.classList.remove("added"); add.innerHTML = PLUS; }, 1100);
      return;
    }
    if (e.target.closest("[data-inc]")) return setQty(e.target.closest("[data-inc]").dataset.inc, 1);
    if (e.target.closest("[data-dec]")) return setQty(e.target.closest("[data-dec]").dataset.dec, -1);
    if (e.target.closest("[data-rm]"))  return removeItem(e.target.closest("[data-rm]").dataset.rm);
    const fav = e.target.closest(".card__fav");
    if (fav) { fav.style.color = fav.style.color === "var(--wood)" ? "" : "var(--wood)"; }
  });

  document.getElementById("cartBtn").addEventListener("click", openCart);
  document.getElementById("cartClose").addEventListener("click", closeCart);
  els.scrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeCart(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && detailOpen) closeDetail(); });

  /* ---------- Product description modal ---------- */
  const pmodal = document.getElementById("proteinModal");
  const pmMore = document.getElementById("proteinMore");
  if (pmodal && pmMore) {
    const openP = () => { pmodal.hidden = false; document.body.style.overflow = "hidden"; };
    const closeP = () => { pmodal.hidden = true; document.body.style.overflow = ""; };
    pmMore.addEventListener("click", openP);
    pmodal.addEventListener("click", (e) => { if (e.target.closest("[data-pmclose]")) closeP(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !pmodal.hidden) closeP(); });
  }

  /* ---------- Checkout (Shopify Storefront cart → secure checkout) ---------- */
  const checkoutBtn = document.getElementById("checkoutBtn");
  const checkoutNote = document.getElementById("checkoutNote");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      checkoutBtn.classList.add("is-loading");
      const r = await cart.checkout(); // redirects to Shopify when LIVE
      checkoutBtn.classList.remove("is-loading");
      if (!r.ok && checkoutNote) {
        checkoutNote.textContent = r.reason === "demo"
          ? T.t("checkout_demo")
          : r.reason === "empty" ? T.t("checkout_empty") : "Error: " + r.reason;
        checkoutNote.classList.add("is-on");
      }
    });
  }

  /* ---------- Refined language / currency dropdowns ---------- */
  const CHECK_SVG =
    '<svg class="nnsel__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M20 6L9 17l-5-5"/></svg>';

  const openMenus = new Set();
  function closeAllMenus() { [...openMenus].forEach((m) => m.close()); }
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".nnsel")) closeAllMenus();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAllMenus(); });

  function buildDropdown({ btn, pop, cur, items, isActive, onPick }) {
    const api = { render, close };

    function render() {
      pop.innerHTML = "";
      items.forEach((it, i) => {
        const active = isActive(it);
        const opt = document.createElement("button");
        opt.type = "button";
        opt.className = "nnsel__opt";
        opt.setAttribute("role", "option");
        opt.setAttribute("aria-selected", active ? "true" : "false");
        opt.style.setProperty("--i", i);
        opt.innerHTML =
          '<span class="nnsel__badge' + (it.sym ? " nnsel__badge--sym" : "") + '">' + it.badge + "</span>" +
          '<span class="nnsel__txt"><span class="nnsel__main">' + it.main + "</span>" +
          '<span class="nnsel__sub">' + it.sub + "</span></span>" + CHECK_SVG;
        opt.addEventListener("click", () => { close(); onPick(it); });
        pop.appendChild(opt);
      });
      const act = items.find(isActive);
      if (cur && act) cur.textContent = act.trigger;
    }

    function open() {
      closeAllMenus();
      pop.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
      openMenus.add(api);
    }
    function close() {
      pop.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
      openMenus.delete(api);
    }
    function toggle() { pop.classList.contains("is-open") ? close() : open(); }

    btn.addEventListener("click", (e) => { e.stopPropagation(); toggle(); });
    btn.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
        e.preventDefault(); open();
        const sel = pop.querySelector('.nnsel__opt[aria-selected="true"]') || pop.querySelector(".nnsel__opt");
        if (sel) sel.focus();
      }
    });
    pop.addEventListener("keydown", (e) => {
      const opts = [...pop.querySelectorAll(".nnsel__opt")];
      const idx = opts.indexOf(document.activeElement);
      if (e.key === "ArrowDown") { e.preventDefault(); (opts[idx + 1] || opts[0]).focus(); }
      else if (e.key === "ArrowUp") { e.preventDefault(); (opts[idx - 1] || opts[opts.length - 1]).focus(); }
      else if (e.key === "Escape") { close(); btn.focus(); }
    });

    render();
    return api;
  }

  const LANG_NAMES = { fr: "Français", en: "English", es: "Español" };
  const langDD = buildDropdown({
    btn: document.getElementById("langBtn"),
    pop: document.getElementById("langPop"),
    cur: document.getElementById("langCur"),
    items: T.langs.map((l) => ({
      code: l.code, trigger: l.label, badge: l.label,
      main: LANG_NAMES[l.code] || l.label, sub: l.label,
    })),
    isActive: (it) => it.code === T.lang,
    onPick: (it) => T.setLang(it.code),
  });

  /* ---------- Per-language slider / hero banner image ---------- */
  const sliderImg = document.getElementById("sliderImg");
  const heroImg = document.getElementById("heroImg");
  /* Asset base — empty for the standalone file, set to the Shopify asset CDN
     folder when running inside the theme (injected in layout/theme.liquid). */
  const AB = (typeof window !== "undefined" && window.NN_ASSET_BASE) ? window.NN_ASSET_BASE : "";
  /* Resolve each language variant from its embedded element so the URLs survive
     bundling (blob:), the Shopify CDN (asset_url) AND plain dev — no hard-coded paths. */
  const srcOf = (id, fb) => { const e = document.getElementById(id); return (e && (e.currentSrc || e.src)) || fb; };
  const HERO_SRC = {
    fr: (heroImg && (heroImg.currentSrc || heroImg.src)) || (AB + "hero-fr.jpg"),
    en: srcOf("heroImg_en", AB + "hero-en.jpg"),
    es: srcOf("heroImg_es", AB + "hero-es.jpg"),
  };
  const SLIDER_SRC = {
    fr: (sliderImg && (sliderImg.currentSrc || sliderImg.src)) || (AB + "slider-fr.jpg"),
    en: srcOf("sliderImg_en", AB + "slider-en.jpg"),
    es: srcOf("sliderImg_es", AB + "slider-es.jpg"),
  };
  function setSliderImg() {
    if (sliderImg) sliderImg.src = SLIDER_SRC[T.lang] || SLIDER_SRC.fr;
    if (heroImg) heroImg.src = HERO_SRC[T.lang] || HERO_SRC.fr;
  }
  setSliderImg();

  /* Localize everything on first paint, then keep JS-generated content in sync. */
  T.apply(document);
  T.onChange(() => {
    refreshCatalog();
    buildTrust();
    render();          // cart: empty copy, line names, remove/qty labels, ship note
    refreshPrices();
    renderAmazon();
    renderBundles();
    setSliderImg();
    langDD.render();
  });

  /* ---------- Currency / market selector (Shopify Markets) ---------- */
  const SYM = { EUR: "€", USD: "$", CAD: "$", GBP: "£" };
  const curDD = buildDropdown({
    btn: document.getElementById("curBtn"),
    pop: document.getElementById("curPop"),
    cur: document.getElementById("curCur"),
    items: NN.markets.list.map((m) => ({
      code: m.country, trigger: SYM[m.currency] || m.currency, badge: SYM[m.currency] || m.currency, sym: true,
      main: (m.label.split("·")[0] || m.country).trim(), sub: m.currency,
    })),
    isActive: (it) => it.code === NN.markets.current().country,
    onPick: (it) => NN.markets.set(it.code),
  });

  /* ---------- Bundles (Egyptian-themed, 15% off, currency-aware) ---------- */
  const BUNDLE_DISCOUNT = 0.15;
  const BUNDLES = [
    { key: "b1", handles: ["lions", "coffee", "mush10"] },
    { key: "b2", handles: ["testo", "goat", "protein"] },
    { key: "b3", handles: ["moringa", "ashwa"] },
  ];
  function renderBundles() {
    const grid = document.getElementById("bundlesGrid");
    if (!grid) return;
    grid.innerHTML = BUNDLES.map((b) => {
      const total = b.handles.reduce((s, h) => s + NN.priceOf(h), 0);
      const now = total * (1 - BUNDLE_DISCOUNT);
      const items = b.handles.map((h) => {
        const p = NN.byHandle(h);
        const src = (document.getElementById("prodsrc-" + h) || {}).src || "";
        const nm = T.t("prod_" + h + "_name", p ? p.name : h);
        return `<li class="bundle__item"><img class="bundle__thumb" src="${src}" alt="" loading="lazy" /><span>${nm}</span></li>`;
      }).join("");
      return `<article class="bundle reveal is-in">
        <div class="bundle__head">
          <span class="bundle__badge">${T.t("bundle_badge")}</span>
          <h3 class="bundle__name">${T.t(b.key + "_name")}</h3>
          <span class="bundle__tag">${T.t(b.key + "_tag")}</span>
        </div>
        <p class="bundle__desc">${T.t(b.key + "_desc")}</p>
        <ul class="bundle__items">${items}</ul>
        <div class="bundle__foot">
          <div class="bundle__price">
            <span class="bundle__was">${NN.money(total)}</span>
            <span class="bundle__now">${NN.money(now)}</span>
          </div>
          <button class="btn btn--primary" data-bundle="${b.key}"><span>${T.t("bundle_add")}</span> <span class="arr">→</span></button>
        </div>
      </article>`;
    }).join("");
  }
  document.addEventListener("click", (e) => {
    const bb = e.target.closest("[data-bundle]");
    if (!bb) return;
    const b = BUNDLES.find((x) => x.key === bb.dataset.bundle);
    if (!b) return;
    b.handles.forEach((h) => cart.add(h));
    openCart();
  });

  /* ---------- Keep the whole UI in sync (cart + market changes) ---------- */
  cart.onChange(() => { render(); refreshPrices(); renderAmazon(); renderBundles(); curDD.render(); });
  render();
  refreshPrices();
  renderAmazon();
  renderBundles();

  /* ---------- Trust marquee (duplicated for seamless loop) ---------- */
  const trustItems = [
    { key: "trust_1", icon: '<circle cx="12" cy="12" r="9"/><line x1="5.6" y1="5.6" x2="18.4" y2="18.4"/>' },
    { key: "trust_2", icon: '<path d="M9 3h6"/><path d="M10 3v6l-5.2 9A2 2 0 0 0 6.6 21h10.8a2 2 0 0 0 1.8-3l-5.2-9V3"/><path d="M7.5 14.5h9"/>' },
    { key: "trust_3", icon: '<path d="M12 21v-8"/><path d="M12 13c0-3.2 2.6-5.2 6.2-5.2C18.2 11 15.6 13 12 13z"/><path d="M12 15.5c0-2.6-2.1-4.6-5.2-4.6C6.8 13.5 8.9 15.5 12 15.5z"/>' },
    { key: "trust_4", icon: '<path d="M12 22V8"/><path d="M12 8c0-2.2 1.6-4 4.2-4C16.2 6.2 14.6 8 12 8z"/><path d="M12 8c0-2.2-1.6-4-4.2-4C7.8 6.2 9.4 8 12 8z"/><path d="M12 14c0-2 1.5-3.6 4-3.6C16 12.4 14.5 14 12 14z"/><path d="M12 14c0-2-1.5-3.6-4-3.6C8 12.4 9.5 14 12 14z"/>' },
    { key: "trust_5", icon: '<line x1="12" y1="2" x2="12" y2="22"/><line x1="2.7" y1="12" x2="21.3" y2="12"/><line x1="4.9" y1="4.9" x2="19.1" y2="19.1"/><line x1="19.1" y1="4.9" x2="4.9" y2="19.1"/><path d="M12 5.5 9.6 7.9M12 5.5l2.4 2.4M12 18.5l-2.4-2.4M12 18.5l2.4-2.4"/>' },
    { key: "trust_6", icon: '<path d="M12 22s7-5.8 7-12a7 7 0 1 0-14 0c0 6.2 7 12 7 12z"/><circle cx="12" cy="10" r="2.5"/>' },
  ];
  const track = document.getElementById("trustTrack");
  // Gold gradient applied to the icon strokes themselves (no medallion).
  const goldDefs =
    '<svg width="0" height="0" style="position:absolute" aria-hidden="true">' +
    '<defs><linearGradient id="goldStroke" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#9c6a2e"/><stop offset=".3" stop-color="#f0dca0"/>' +
    '<stop offset=".58" stop-color="#c79140"/><stop offset="1" stop-color="#eccd86"/>' +
    '</linearGradient></defs></svg>';
  if (!document.getElementById("trust-gold-defs")) {
    const wrap = document.createElement("div");
    wrap.id = "trust-gold-defs";
    wrap.innerHTML = goldDefs;
    document.body.appendChild(wrap);
  }
  const icon = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="url(#goldStroke)" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`;
  function buildTrust() {
    const html = trustItems.map((it) => `<span class="trust__item"><span class="trust__ic">${icon(it.icon)}</span>${T.t(it.key)}</span>`).join("");
    track.innerHTML = html + html;
  }
  buildTrust();

  /* ---------- Announcement rotation ---------- */
  const aItems = Array.from(document.querySelectorAll(".announce__item"));
  let aIdx = 0;
  setInterval(() => {
    aItems[aIdx].classList.remove("is-on");
    aIdx = (aIdx + 1) % aItems.length;
    aItems[aIdx].classList.add("is-on");
  }, 3200);

  /* ---------- Header shadow on scroll ---------- */
  const header = document.getElementById("header");
  const onScroll = () => {
    const stuck = header.getBoundingClientRect().top <= 0;
    header.classList.toggle("is-stuck", stuck);
    header.classList.toggle("scrolled", stuck);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Reveal on scroll (blur → sharp, rise, fade) ---------- */
  const hasIO = "IntersectionObserver" in window;
  const revealEls = document.querySelectorAll(".reveal");
  // Reveal anything already in the viewport so above-the-fold content shows on first paint.
  const revealVisible = () => {
    const vh = window.innerHeight || 800;
    revealEls.forEach((el) => {
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add("is-in");
    });
  };
  if (hasIO) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -12% 0px" });
    revealEls.forEach((el) => io.observe(el));
    revealVisible();
    window.addEventListener("load", revealVisible);
    // Scroll fallback: reveal on scroll even if IO is throttled/finicky.
    let ticking = false;
    const onScrollReveal = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { revealVisible(); ticking = false; });
    };
    window.addEventListener("scroll", onScrollReveal, { passive: true });
    window.addEventListener("resize", onScrollReveal, { passive: true });
  } else {
    // No IntersectionObserver: just show everything so nothing stays hidden.
    revealEls.forEach((el) => el.classList.add("is-in"));
  }

  /* ---------- Mobile navigation ---------- */
  const mnav = document.getElementById("mnav");
  const mnavScrim = document.getElementById("mnavScrim");
  const menuToggle = document.getElementById("menuToggle");
  const mnavClose = document.getElementById("mnavClose");
  if (mnav && menuToggle) {
    const openNav = () => {
      mnav.classList.add("is-open"); mnav.setAttribute("aria-hidden", "false");
      if (mnavScrim) { mnavScrim.hidden = false; requestAnimationFrame(() => mnavScrim.classList.add("is-open")); }
      menuToggle.setAttribute("aria-expanded", "true");
    };
    const closeNav = () => {
      mnav.classList.remove("is-open"); mnav.setAttribute("aria-hidden", "true");
      if (mnavScrim) { mnavScrim.classList.remove("is-open"); setTimeout(() => { mnavScrim.hidden = true; }, 300); }
      menuToggle.setAttribute("aria-expanded", "false");
    };
    menuToggle.addEventListener("click", () => mnav.classList.contains("is-open") ? closeNav() : openNav());
    if (mnavClose) mnavClose.addEventListener("click", closeNav);
    if (mnavScrim) mnavScrim.addEventListener("click", closeNav);
    mnav.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeNav));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && mnav.classList.contains("is-open")) closeNav(); });
    // close if resized up to desktop
    window.addEventListener("resize", () => { if (window.innerWidth > 860 && mnav.classList.contains("is-open")) closeNav(); });
  }

  /* ---------- Moringa slideshow ---------- */
  const mslides = document.querySelector("[data-mslides]");
  if (mslides) {
    const bgs = [...mslides.querySelectorAll(".mbg")];
    const copies = [...mslides.querySelectorAll(".mcopy")];
    const dots = [...mslides.querySelectorAll(".mdot")];
    const count = bgs.length;
    let idx = 0, prev = -1, timer = null;
    const DUR = 6000;
    const show = (n) => {
      const next = (n + count) % count;
      if (next === idx) return;
      prev = idx;
      idx = next;
      bgs.forEach((b, i) => {
        b.classList.toggle("is-active", i === idx);
        b.classList.toggle("mbg--prev", i === prev && i !== idx);
      });
      copies.forEach((c) => c.classList.toggle("is-active", +c.dataset.slide === idx));
      dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
    };
    const start = () => { stop(); timer = setInterval(() => show(idx + 1), DUR); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    dots.forEach((d) => d.addEventListener("click", () => { show(+d.dataset.go); start(); }));
    // prev / next arrows — keep autoplay running after a manual jump
    mslides.querySelectorAll(".marrow").forEach((a) =>
      a.addEventListener("click", () => { show(idx + (+a.dataset.dir)); start(); })
    );
    // autoplay keeps running even when the cursor is over the slideshow.
    // pause only when off-screen to save work.
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((ents) => {
        ents.forEach((e) => (e.isIntersecting ? start() : stop()));
      }, { threshold: 0.15 }).observe(mslides);
    } else { start(); }
  }

  /* ---------- Newsletter ---------- */
  const form = document.getElementById("newsForm");
  if(form) form.addEventListener("submit", (e) => {
    e.preventDefault();
    form.reset();
    const note = document.getElementById("newsNote");
    note.textContent = T.t("news_success");
    note.style.color = "var(--gold-lt)";
  });

  /* ---------- Contact form ---------- */
  const cForm = document.getElementById("contactForm");
  if (cForm) {
    cForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const note = document.getElementById("contactNote");
      const fd = new FormData(cForm);
      const ok = ["name", "email", "message"].every((k) => String(fd.get(k) || "").trim());
      if (!ok) {
        if (note) { note.textContent = T.t("contact_error"); note.style.color = "oklch(0.55 0.15 32)"; }
        return;
      }
      cForm.reset();
      if (note) { note.textContent = T.t("contact_success"); note.style.color = ""; }
    });
  }

  /* ---------- Cursor glow (smooth trailing warm halo) ---------- */
  const glow = document.getElementById("cursorGlow");
  if (glow && matchMedia("(hover:hover) and (pointer:fine)").matches) {
    let tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    let cx = tx, cy = ty;
    const tick = () => {
      cx += (tx - cx) * 0.16;
      cy += (ty - cy) * 0.16;
      glow.style.transform = `translate(${cx}px, ${cy}px)`;
      requestAnimationFrame(tick);
    };
    window.addEventListener("mousemove", (e) => {
      tx = e.clientX; ty = e.clientY;
      glow.classList.add("on");
    });
    window.addEventListener("mouseout", (e) => {
      if (!e.relatedTarget) glow.classList.remove("on");
    });
    tick();
  }
})();
